import type { TaskData } from "@/components/TaskRow";
import { belongsToScope, type ScopedTask } from "@/lib/views";

export type ZenScope =
  | { kind: "myDay"; inOrder: boolean }
  | { kind: "list"; listId: string }
  | { kind: "children"; parentId: string };

const IN_ORDER_CONTEXT = "in-order";

export function rootZenScope(frame: { kind: "myDay" | "list" | "task"; contextId: string | null }): ZenScope {
  switch (frame.kind) {
    case "myDay": return { kind: "myDay", inOrder: frame.contextId === IN_ORDER_CONTEXT };
    case "list": return { kind: "list", listId: frame.contextId ?? "" };
    case "task": return { kind: "children", parentId: frame.contextId ?? "" };
  }
}

// Mirrors ZenController#resolve_frame: would the server still queue this task in the frame?
export function stillInZenScope(task: TaskData, scope: ZenScope, today: string): boolean {
  if (task.status !== "pending") return false;
  const dto = task as unknown as ScopedTask;
  switch (scope.kind) {
    case "myDay": return belongsToScope(dto, "myday", today) && (!scope.inOrder || !!task.myDaySequential);
    case "list": return belongsToScope(dto, `list:${scope.listId}`, today);
    case "children": return task.parentId === scope.parentId;
  }
}
